import { render, staticRenderFns } from "./PokerTablePlayers.vue?vue&type=template&id=2519d05f&scoped=true"
import script from "./PokerTablePlayers.js?vue&type=script&lang=js&external"
export * from "./PokerTablePlayers.js?vue&type=script&lang=js&external"
import style0 from "./PokerTablePlayers.vue?vue&type=style&index=0&id=2519d05f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2519d05f",
  null
  
)

export default component.exports